module.exports = __webpack_public_path__ + "img/tap.1332c2af.svg";